import { cn, DropdownMenuItem } from '@sib/ui';
import { Check } from '@sib/ui/icons';

export enum OrgType {
  Parent = 'parent',
  Subsidiary = 'subsidiary',
}

export interface OrganizationSwitchDropdownItemData {
  id: string;
  name: string;
  type: OrgType;
}

interface OrganizationSwitchDropdownItemProps {
  org: OrganizationSwitchDropdownItemData;
  isSelected: boolean;
  onSelect: (org: OrganizationSwitchDropdownItemData) => void;
}

export const OrganizationSwitchDropdownItem = ({
  org,
  isSelected,
  onSelect,
}: OrganizationSwitchDropdownItemProps) => (
  <DropdownMenuItem
    onClick={() => onSelect(org)}
    className={cn(
      'flex cursor-pointer items-center justify-between gap-2 border-none px-2 py-1.5',
      org.type === OrgType.Parent && 'pt-0'
    )}
  >
    <span className={cn(org.type === OrgType.Parent && 'font-medium')}>
      {org.name}
    </span>
    {isSelected && <Check className="text-primary h-4 w-4" />}
  </DropdownMenuItem>
);
